// extracted by mini-css-extract-plugin
export default {"capsuleTabs":"CapsuleTabs_capsuleTabs__NqUzG","tabBtn":"CapsuleTabs_tabBtn__Hyw+C","active":"CapsuleTabs_active__VCeFg"};